import React, { useEffect, useState } from 'react';
import API_BASE_URL from "Components/API";
import Loading from "Components/Loading";
import { useTranslation } from "react-i18next";
import { ReactComponent as ChevronLeft } from "Assets/icons/chevronLeft.svg";
import { ReactComponent as ChevronRight } from "Assets/icons/chevronRight.svg";

const CodalReports = () => {
    const [data, setData] = useState([]);
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;
    return (
        <div className="megaMenuContent">
            <div className="col-12 text-start mt-2">
                <a href="https://codal.ir/ReportList.aspx?search&Symbol=%D8%A7%D9%86%D8%B1%DA%98%DB%8C&LetterType=-1&Isic=671203&AuditorRef=-1&PageNumber=1&Audited&NotAudited&IsNotAudited=false&Childs&Mains&Publisher=false&CompanyState=0&Category=-1&CompanyType=1&Consolidatable&NotConsolidatable" target="_blank" className="btn rounded-5 bg-primary text-white d-inline-flex justify-content-center align-items-center gap-1" >
                    {t("view_all_codal_announcements")}
                    <span className="btn p-0 btn-read-more rounded-circle bg-white text-blue d-flex justify-content-center align-items-center">
                        {currentLang === "en" ? <ChevronRight width={15} height={10} /> : <ChevronLeft width={15} height={10} />}
                    </span>
                </a>
            </div>
        </div>
    );
};

export default CodalReports;
